import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeDropdownDrawer from 'assets/components/dropdown/themes/Theme.Dropdown.Drawer';

const ThemeDropdownButtonDrawer: Template.DropdownButton.Import['subcomponents'] = {
  button: { class: ThemeButtonCircle, animation: { trigger: 'click' } },
  dropdown: { class: ThemeDropdownDrawer },
};
export default ThemeDropdownButtonDrawer;
